import OnyxLogo from '../../img/companies/onyx-logo.svg';

const logoDivStyle = {
    'background': 'rgba(0, 0, 0, 0.87)',
    'padding': '5rem'
}
const logoStyle = {
    'display': 'block',
    'margin': '0 auto',
    'width': '100%',
    'max-width': '300px'
}
export const OnyxHeader = () => {
    return (
        <div style={logoDivStyle}>
            <img style={logoStyle} src={OnyxLogo} />
        </div>
    )
}